import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledEmpty} from "@/shared/StyledComponents";
import {Action, ACTION_SPACE, ActionBase} from "@/shared/types";
import {PracticeData} from "@/libwyze-shared/types";
import {SiteHelper} from "./SiteHelper";
import {BaseListFragment} from "../../shared/BaseListFragment";
import {Button, Grid, Typography} from "@mui/material";
import {PD_LG, PD_XLG} from "../../shared/dimens";
import {WebPageEditorFragment} from "./webpage/WebPageEditorFragment";
import {AddOutlined} from "@mui/icons-material";
import {PathComponent} from "../../shared";
import {Outlet} from "react-router-dom";
import {Site, Sites} from "../../vantage-shared/types";
import defaultTemplateImage from "./res/images/default_template.png";

export type SitesFragmentProps = PageFragmentProps & {}

type SitesFragmentState = PageFragmentState & {}

export class SitesFragment extends BaseListFragment<Site, Sites, SitesFragmentProps, SitesFragmentState> {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: ":site_id",
        children: WebPageEditorFragment.nestedPaths(),
        render: pathProps => <WebPageEditorFragment
          siteId={pathProps.params.site_id}
          path={pathProps}
          onBack={() => pathProps.navigate("../")}
        />,
      },
    ];
  }

  private readonly actions: ActionBase[] = [
    ACTION_SPACE,
    new Action("New Site", () => {
      SiteHelper.createNew();
    }, AddOutlined)
      .setVariant("contained"),
  ];

  constructor(props: SitesFragmentProps, context: any) {
    super(props, context, new Sites(PracticeData.provider().practiceId));
  }

  protected getTitle(): string | null | undefined {
    return "Sites";
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx(this.actions);
  }

  protected renderContainerContent(): React.ReactElement | null {
    if (this.props.path.params.site_id) {
      return <Outlet/>;
    }
    return super.renderContainerContent();
  }

  renderContent(): ReactElement {
    const items = this.loader.getListItems();
    if (!(items?.length > 0)) {
      return <StyledEmpty emptyConfig={{
        title: "Create a Website",
        text: "Set up your own, personalized presence on the web and reach patients by creating a website.",
        iconUrl: "/images/landing-page.svg",
        action: new Action("Create a Website", () => SiteHelper.createNew()),
      }}/>;
    }
    return <div style={{width: "100%", padding: PD_LG}}>
      <Grid container>
        {items.map(item => <Grid xs={12} sm={6} md={4} lg={3}>
          <Button
            onClick={() => this.props.path.navigate(`${item.id}`)}
            style={{width: "100%", height: "100%"}}>
            <StyledBoxColumn style={{width: "100%", flexGrow: 1, padding: PD_XLG}}>
              <img src={defaultTemplateImage}
                   style={{width: "100%", aspectRatio: 1, objectFit: "contain"}}/>
              <Typography>{item.name}</Typography>
            </StyledBoxColumn>
          </Button>
        </Grid>)}
      </Grid>
    </div>;
  }
}